<div class="wm-m-artifact">
  @if (!artifact) {
    <div>
      <p-progressBar mode="indeterminate"></p-progressBar>
    </div>
  }
  @if (artifact?.artifactType === 'Page.FullpageScreenshot') {
    <div>
      <div class="artifact-label-with-line">
        <span class="artifact-label">Screenshot</span>
        <span class="artifact-label-line"></span>
      </div>
      <div class="artifact-time">{{ timeDiff }}</div>
      <wm-screenshot-artifact [artifact]="artifact" [summary]="summary"></wm-screenshot-artifact>
    </div>
  }
  @if (artifact?.artifactType === 'DOM.DomLayoutTree') {
    <div>
      <div class="artifact-label-with-line">
        <span class="artifact-label">State Data</span>
        <span class="artifact-label-line"></span>
      </div>
      <div class="artifact-time">{{ timeDiff }}</div>
      <div>
        <button attr.data-testing-id="artifact-show-statedata-{{artifactId}}" [disabled]="!(artifact?.data?.layoutTreeId)" (click)="openStatedataViewer(artifact?.data?.layoutTreeId, associatedState)" pButton class="p-button-text state-data-btn">
          <fa-icon icon="eye" size="lg"></fa-icon>
          Show StateData
        </button>
        <div>State {{ artifact.id }}</div>
      </div>
    </div>
  }

  @if (artifact?.artifactType === 'Action.ActionStart') {
    <div>
      <div class="artifact-label-with-line">
        <span class="artifact-label">Action Start</span>
        <span class="artifact-type">SELENIUM</span><!-- TODO: this must be determinded dynamically -->
        <span class="artifact-label-line"></span>
      </div>
      <div class="artifact-time">{{ timeDiff }}</div>
      <wm-selenium-action-artifact [artifactData]="artifact" [summary]="summary"></wm-selenium-action-artifact>
    </div>
  }
  @if (artifact?.artifactType === 'Action.ActionFinish') {
    <div>
      <div class="artifact-label-with-line">
        <span class="artifact-label">Action End</span>
        <span class="artifact-type">SELENIUM</span><!-- TODO: this must be determinded dynamically -->
        <span class="artifact-label-line"></span>
      </div>
      <div class="artifact-time">{{ timeDiff }}</div>
      <wm-selenium-action-artifact [artifactData]="artifact" [summary]="summary"></wm-selenium-action-artifact>
    </div>
  }

  @if (artifact?.artifactType === 'Page.A11yReport') {
    <div>
      <div class="artifact-label-with-line">
        <span class="artifact-label">Accessibility Report</span>
        <span class="artifact-label-line"></span>
      </div>
      <div class="artifact-time">{{ timeDiff }}</div>
      <wm-a11yreport-artifact [artifact]="artifact"></wm-a11yreport-artifact>
    </div>
  }

  @if (artifact?.artifactType === 'Page.ContentAnalysis') {
    <div>
      <div class="artifact-label-with-line">
        <span class="artifact-label">Accessibility Report</span>
        <span class="artifact-label-line"></span>
      </div>
      <div class="artifact-time">{{ timeDiff }}</div>
      <wm-contentanalysis-artifact [artifact]="artifact"></wm-contentanalysis-artifact>
    </div>
  }
</div>
